module.exports = __webpack_public_path__ + "img/step2.792e985b.jpg";